import { GRANULARITIES } from './constants';
import type { Granularity } from './types';

/** Bars narrower than this many per span stop being hoverable. */
const MAX_TIMELINE_BUCKETS = 160;
const MIN_TIMELINE_BUCKETS = 6;

/** The finest granularity the span can carry without the bars going sub-pixel. */
export function deriveGranularity(spanMs: number): Granularity {
  return (
    GRANULARITIES.find((entry) => spanMs / entry.ms <= MAX_TIMELINE_BUCKETS) ?? GRANULARITIES[GRANULARITIES.length - 1]
  );
}

export function granularityChoices(spanMs: number): Granularity[] {
  const choices = GRANULARITIES.filter((entry) => {
    const count = spanMs / entry.ms;
    return count >= MIN_TIMELINE_BUCKETS && count <= MAX_TIMELINE_BUCKETS * 2.5;
  });
  return choices.length > 0 ? choices : [deriveGranularity(spanMs)];
}
